"use strict";
var __decorate = (this && this.__decorate) || function (decorators, target, key, desc) {
    var c = arguments.length, r = c < 3 ? target : desc === null ? desc = Object.getOwnPropertyDescriptor(target, key) : desc, d;
    if (typeof Reflect === "object" && typeof Reflect.decorate === "function") r = Reflect.decorate(decorators, target, key, desc);
    else for (var i = decorators.length - 1; i >= 0; i--) if (d = decorators[i]) r = (c < 3 ? d(r) : c > 3 ? d(target, key, r) : d(target, key)) || r;
    return c > 3 && r && Object.defineProperty(target, key, r), r;
};
Object.defineProperty(exports, "__esModule", { value: true });
exports.ElementalBlastAbilityHandler = exports.ElementalBlastActorAbilityFactory = exports.ElementalBlastAbilityArgs = void 0;
const AbilityType_1 = require("../../core/abilities/AbilityType");
const ActorAbilityState_1 = require("../../core/actors/ActorAbilityState");
const Registries_1 = require("../../core/state/Registries");
const Target_1 = require("../../core/Target");
const Random_1 = require("../../utils/Random");
const AbilityDamage_1 = require("../../core/AbilityDamage");
class ElementalBlastAbilityArgs {
    constructor(target) {
        this.target = target;
        this.__type = AbilityType_1.AbilityType.ElementalBlast;
        this.__typeName = "ElementalBlast";
    }
}
exports.ElementalBlastAbilityArgs = ElementalBlastAbilityArgs;
let ElementalBlastActorAbilityFactory = class ElementalBlastActorAbilityFactory {
    mk() {
        return new ActorAbilityState_1.ActorAbilityState("ElementalBlast", "AllEnemies", 0);
    }
};
ElementalBlastActorAbilityFactory = __decorate([
    Registries_1.ActorAbilities.register("ElementalBlast")
], ElementalBlastActorAbilityFactory);
exports.ElementalBlastActorAbilityFactory = ElementalBlastActorAbilityFactory;
let ElementalBlastAbilityHandler = class ElementalBlastAbilityHandler {
    init(sequence, container, actorId) { }
    activate(sequence, container, ability) {
        const selfId = container.getActor(ability.invokerId).ownerId || ability.invokerId;
        const damages = Array.of({
            key: "SonicCrystalActive",
            damageType: "Sonic"
        }, {
            key: "FireCrystalActive",
            damageType: "Fire"
        }, {
            key: "NatureCrystalActive",
            damageType: "Nature"
        }, {
            key: "FrostCrystalActive",
            damageType: "Frost"
        }).filter(({ key }) => container.readLocal(selfId, key, false));
        if (damages.length === 0) {
            // silently do nothing
            return;
        }
        // randomly pick from these
        const damage = (0, Random_1.randomElement)(damages);
        container.applyMultiAttack({
            sequence,
            abilityKey: ability.args.__typeName,
            attackType: "magic",
            attackerId: ability.invokerId,
            targets: container.selectLivingTargets(ability.invokerId, Target_1.Target.AllEnemies)
                .map(targetId => ({
                targetId,
                damages: [
                    AbilityDamage_1.AbilityDamage.Focus(damage.damageType, 120)
                ],
            }))
        });
    }
};
ElementalBlastAbilityHandler = __decorate([
    Registries_1.Abilities.register(AbilityType_1.AbilityType.ElementalBlast)
], ElementalBlastAbilityHandler);
exports.ElementalBlastAbilityHandler = ElementalBlastAbilityHandler;
